import {make} from 'vuex-pathify'

let txUseData = window.txUseData ? window.txUseData : 'user'

export const KEY = txUseData === 'user' ? 'mapData' : 'adminMapData'

function isSet(obj, key) {
    return obj && obj[key] !== typeof undefined
}

let data = window[KEY];

export const initState = (data) => {
    return {
        mapLayout: data?.mapLayout || "vertical",
        mapSize: data?.mapSize || "30x40cm",
        template: data?.template || "lovemap",
    }
}

export const TO_SAVE_BASE = ['mapLayout', 'mapSize', 'template']


const state = initState(data);

const mutations = {
    ...make.mutations(state),
}

const getters = {}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
